import { useMemoizedFn } from 'ahooks';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { getStats } from '@/services/topicService';
import JSONModal from '@/components/JSONModal';

export default function StatsModal({ overview, visible, handleClose }) {
  const [json, setJson] = useState({});
  const [loading, setLoading] = useState(false);

  const loadData = useMemoizedFn(async () => {
    setLoading(true);
    setJson('{}');
    try {
      const { data } = await getStats(overview);
      setJson(data);
    } catch (error) {
      console.trace(error);
      throw error;
    } finally {
      setLoading(false);
    }
  });

  useEffect(() => {
    if (visible) {
      loadData();
    }
  }, [visible, loadData]);

  return (
    <JSONModal
      visible={visible}
      handleClose={handleClose}
      json={json}
      loading={loading}
      title={
        <Header>
          查看Stats
          <HeaderTag>{overview.topic}</HeaderTag>
        </Header>
      }
    />
  );
}

const Header = styled.div`
  display: flex;
`;

const HeaderTag = styled.div`
  background: rgba(102, 136, 255, 0.12);
  border-radius: 6px;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  padding: 2px 10px;
  color: #6688ff;
  margin-left: 12px;
`;
